import React, { Fragment, useContext, useState } from 'react';
import { H4, LI, P, Image, UL, Btn } from '../../../AbstractElements';
import { getVisibleproducts } from '../../../Services/Ecommerce.service';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { Row, Card } from 'reactstrap';
import { TfiShoppingCart } from 'react-icons/tfi';
import { FiEye } from 'react-icons/fi';

import CartContext from '../../../Context/Ecommerce/Cart';
import ProductModal from './ProductModal';
import FilterContext from '../../../Context/Ecommerce/Filter';
import ProductContext from '../../../Context/Ecommerce/Product';

const ProductGrid = () => {
  const Navigate = useNavigate();
  const { addToCart } = useContext(CartContext);
  const { productItem, symbol } = useContext(ProductContext);
  const [dataid, setDataid] = useState();
  const [openModal, setOpenModal] = useState(false);

  const onClickHandle = (i) => {
    setOpenModal(true);
    setDataid(i.id);
  };

  const quantity = 1;
  const AddToCarts = (item, quantity) => {
    addToCart(item, quantity);
    Navigate(`${process.env.PUBLIC_URL}/ecommerce/cart`);
  };

  var images = require.context('../../../assets/images', true);
  const dynamicImage = (image) => {
    return images(`./${image}`);
  };
  const context = useContext(FilterContext);
  const products = getVisibleproducts(productItem, context.filter);
  return (
    <Fragment>
      <div className='product-wrapper-grid'>
        <Row className='gridRow'>
          {products &&
            products.map((item) => {
              return (
                <div id='gridId' className='col-xl-3 col-lg-4 col-sm-6 xl-25' key={item.id}>
                  <Card>
                    <div className='product-box'>
                      <div className='product-img'>
                        {item.status === 'Sale' ? <span className='ribbon ribbon-danger'>{item.status}</span> : ''}
                        {item.status === '50%' ? <span className='ribbon ribbon-success ribbon-right'>{item.status}</span> : ''}
                        {item.status === 'gift' ? (
                          <span className='ribbon ribbon-secondary ribbon-vertical-left'>
                            <i className='icon-gift'>{item.status}</i>
                          </span>
                        ) : (
                          ''
                        )}
                        {item.status === 'love' ? (
                          <span className='ribbon ribbon-bookmark ribbon-vertical-right ribbon-info'>
                            <i className='icon-heart'>{item.status}</i>
                          </span>
                        ) : (
                          ''
                        )}
                        {item.status === 'Hot' ? <span className='ribbon ribbon ribbon-clip ribbon-warning'>{item.status}</span> : ''}
                        <Image className='img-fluid' src={`${dynamicImage(item.img)}`} alt='' />
                        <div className='product-hover'>
                          <UL className='simple-list flex-row'>
                            <LI>
                              <Btn className='d-flex' color='transparent' onClick={() => AddToCarts(item, quantity)}>
                                <TfiShoppingCart style={{ width: '16px', height: '16px' }} className='me-0' />
                              </Btn>
                            </LI>
                            <LI>
                              <Btn
                                className='d-flex'
                                color='transparent'
                                onClick={() => {
                                  onClickHandle(item);
                                }}
                                datatoggle='modal'>
                                <FiEye style={{ width: '16px', height: '16px' }} className='me-0' />
                              </Btn>
                            </LI>
                          </UL>
                        </div>
                      </div>
                      <div className='product-details'>
                        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page/${item.id}`}>
                          <H4>{item.name}</H4>
                        </Link>
                        <P>{item.note}</P>
                        <div className='product-price'>
                          {symbol} {item.price}
                          <del>
                            {symbol} {item.discountPrice}
                          </del>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              );
            })}
          {openModal && <ProductModal value={openModal} setOpenModal={setOpenModal} dataid={dataid} />}
        </Row>
      </div>
    </Fragment>
  );
};
export default ProductGrid;
